/**
 * 个股页面
 */

import ad from "../modules/ad";
import url from "../modules/url";

//广告
// let index_ad = new ad('All_pages,Stock_quotes_page')
// index_ad.getData().then(function(){
  // //顶部广告
  // index_ad.render($('#adDTT'), 'DTT').then(function(){
  //   document.body.style.paddingTop = document.getElementById("adDTT").clientHeight + "px";
  // })

  // // //底部广告
  // // let BottomPosition = url.getQuery('position') == null ? "DT" : url.getQuery('position');
  // // index_ad.render($('#bottomAD'), BottomPosition)  

  // //中部广告
  // index_ad.render($('#middlead'), 'HQXFB')
  // index_ad.render($('#middlead2'), 'GBSFW')
// })

//全局变量
declare global {
  interface Window{
    stock_code:string;
    stock_market:string;
  }  
}

import { filter404 } from '../modules/404'
filter404()


let code = window.stock_code
let market = window.stock_market

//交易按钮
if( /^\d{6}$/.test(code) && ((market == '1' && code.indexOf('000') != 0) || (market == '0' && code.indexOf('399') != 0))){
  let jyurl = "//wap.eastmoney.com/h52n?type=502&market=" + (market == "1" ? "SH" : "SZ") + "&code=" + code
  $('#lijiaoyi').show()
  $('#lijiaoyi').attr('data-url', jyurl + '&name={name}')
  $('#lijiaoyi').on('click', function(){
    window.location.href = jyurl
  })
}

if(market == "1" || market == "0"){
  $('#liShare').hide()
}else{
  $('#liMore').hide()
}

//加自选按钮
if (market == "1" || market == "0" || market == "113"){
  $('#btn-more-op').show()
}


//require('../modules/old_js/stock')
import "../modules/old_js/stock"